import Vue from 'vue';
import Vuex from 'vuex';
// import 'es6-promise/auto';
import layout from './modules/layout';
import menu from './modules/menu';
import chat from './modules/chat';
import products from './modules/products';
import email from './modules/email';
import todo from './modules/todo';
import firebase_todo from './modules/firebase_todo';
import jobs from './modules/jobs';
import courses from './modules/courses';
import common from './modules/common';
import { alert } from './modules/alert';
import { authentication } from './modules/authentication';
import { users } from './modules/users';

// RDRC
import dashboard from './modules/rdrc/dashboard.js';
import teams from './modules/rdrc/teams.js';
import about from './modules/rdrc/about.js';
import partner from './modules/rdrc/partner.js';
import setting from './modules/rdrc/setting.js';
import contact from './modules/rdrc/contact.js';
import notice from './modules/rdrc/notice.js';
import expertise from './modules/rdrc/expertise.js';
import production from './modules/rdrc/production.js';
import news from './modules/rdrc/news.js';
import research from './modules/rdrc/research.js';
import advocacy from './modules/rdrc/advocacy.js';
import publication from './modules/rdrc/publication.js';
import job from './modules/rdrc/job.js';
import content from './modules/rdrc/content.js';


// Empowerment
import words from './modules/empowerment/words.js';
import gallery from './modules/empowerment/gallery.js';
import stories from './modules/empowerment/stories.js';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {},

    mutations: {
        changeLang (state, payload) {
            localStorage.setItem('currentLanguage', payload.id);
            localStorage.setItem('currentLanguageIcon', payload.icon);
            window.location.reload();
        }
    },

    actions: {
        setLang ({ commit }, payload) {
            commit('changeLang', payload);
        }
    },

    modules: {
        // RDRC
        dashboard,
        teams,
        about,
        partner,
        setting,
        contact,
        notice,
        expertise,
        production,
        news,
        research,
        advocacy,
        publication,
        job,
        content,

        words,
        gallery,
        stories,
        
        alert,
        authentication,
        users,
        layout,
        chat,
        menu,
        products,
        email,
        todo,
        firebase_todo,
        jobs,
        courses,
        common
    }
});

